<modal
  [id]="modalId"
  [header]="'v2.eventApps.snoball.setupTitle' | translate"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="!statusSavingId()"
  [enableBackdropClose]="!statusSavingId()"
  [escapeToClose]="!statusSavingId()"
  [widthClass]="'tw-w-[calc(100%-2rem)] tw-max-w-[760px] lg:tw-w-[760px]'"
  [heightClass]="'tw-h-auto tw-max-h-[90vh]'"
  [showFooterDivider]="false"
  (onCloseModal)="onCloseModal.emit()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-4 tw-py-2 tw-font-inter">
    @if (configurations().length === 0) {
      <p class="tw-py-8 tw-text-center tw-text-sm tw-text-gray-500">{{ 'v2.eventApps.snoball.emptyConfigurations' | translate }}</p>
    } @else {
      <div class="tw-w-full tw-min-w-0 tw-rounded-lg tw-border tw-border-gray-200">
        <app-generic-table
          class="snoball-config-table tw-w-full tw-min-w-0"
          [items]="configurations()"
          [trackBy]="trackByConfiguration"
          [rowKey]="configurationRowKey"
          [pageSize]="configurations().length"
          [style.height.px]="tableHeightPx()"
        >
          <ng-container appGenericTableColumn field="personas" [header]="'v2.eventApps.snoball.personas' | translate" width="200px">
            <ng-template appGenericTableCellDef let-config>
              <app-truncation-tooltip [text]="personaLabels(config)" [hostNgClass]="'tw-font-inter tw-text-sm tw-text-gray-800'"></app-truncation-tooltip>
            </ng-template>
          </ng-container>
          <ng-container appGenericTableColumn field="project_id" [header]="'v2.eventApps.snoball.projectId' | translate" width="184px">
            <ng-template appGenericTableCellDef let-config>
              <app-truncation-tooltip [text]="config.project_id" [hostNgClass]="'tw-font-inter tw-text-sm tw-text-gray-800'"></app-truncation-tooltip>
            </ng-template>
          </ng-container>
          <ng-container appGenericTableColumn field="campaign_id" [header]="'v2.eventApps.snoball.campaignId' | translate" width="184px">
            <ng-template appGenericTableCellDef let-config>
              <app-truncation-tooltip [text]="config.campaign_id" [hostNgClass]="'tw-font-inter tw-text-sm tw-text-gray-800'"></app-truncation-tooltip>
            </ng-template>
          </ng-container>
          @if (canManage()) {
            <ng-container appGenericTableColumn field="status" [header]="'v2.eventApps.snoball.status' | translate" width="120px">
              <ng-template appGenericTableCellDef let-config>
                <div class="tw-flex tw-items-center tw-justify-center">
                  <ng-container [ngTemplateOutlet]="statusControl" [ngTemplateOutletContext]="{ $implicit: config }"></ng-container>
                </div>
              </ng-template>
            </ng-container>
            <ng-container appGenericTableColumn field="actions" [header]="'v2.eventApps.snoball.actions' | translate" width="120px">
              <ng-template appGenericTableCellDef let-config>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
                  <ng-container [ngTemplateOutlet]="rowActions" [ngTemplateOutletContext]="{ $implicit: config }"></ng-container>
                </div>
              </ng-template>
            </ng-container>
          }
        </app-generic-table>
      </div>
    }
  </div>

  @if (canManage()) {
    <div slot="footer" class="tw-flex tw-w-full tw-justify-start tw-px-6 tw-pb-4">
      <button
        type="button"
        class="tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-blue-600 tw-px-4 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-blue-700"
        (click)="onAddConfiguration()"
      >
        <svg class="tw-pointer-events-none tw-h-[14px] tw-w-[14px] tw-shrink-0 tw-text-white" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <g clip-path="url(#snoball-add-configuration)">
            <path
              class="tw-fill-white"
              d="M18.8889 8.88889H11.1111V1.11111C11.1111 0.816426 10.994 0.533811 10.7857 0.325437C10.5773 0.117063 10.2947 0 10 0C9.70532 0 9.4227 0.117063 9.21433 0.325437C9.00595 0.533811 8.88889 0.816426 8.88889 1.11111V8.88889H1.11111C0.816426 8.88889 0.533811 9.00595 0.325437 9.21433C0.117063 9.4227 0 9.70532 0 10C0 10.2947 0.117063 10.5773 0.325437 10.7857C0.533811 10.994 0.816426 11.1111 1.11111 11.1111H8.88889V18.8889C8.88889 19.1836 9.00595 19.4662 9.21433 19.6746C9.4227 19.8829 9.70532 20 10 20C10.2947 20 10.5773 19.8829 10.7857 19.6746C10.994 19.4662 11.1111 19.1836 11.1111 18.8889V11.1111H18.8889C19.1836 11.1111 19.4662 10.994 19.6746 10.7857C19.8829 10.5773 20 10.2947 20 10C20 9.70532 19.8829 9.4227 19.6746 9.21433C19.4662 9.00595 19.1836 8.88889 18.8889 8.88889Z"
            />
          </g>
          <defs>
            <clipPath id="snoball-add-configuration">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {{ 'v2.eventApps.snoball.addConfiguration' | translate }}
      </button>
    </div>
  }
</modal>

<ng-template #statusControl let-config>
  <label
    class="tw-inline-flex tw-cursor-pointer tw-items-center tw-align-middle tw-leading-none"
    [ngxTippy]="(config.status === 'active' ? 'v2.eventApps.snoball.statusActive' : 'v2.eventApps.snoball.statusInactive') | translate"
    [tippyProps]="iconActionTippyProps"
  >
    <input
      type="checkbox"
      class="tw-peer tw-sr-only"
      [checked]="config.status === 'active'"
      [disabled]="statusSavingId() === config.id"
      [attr.aria-label]="(config.status === 'active' ? 'v2.eventApps.snoball.statusActive' : 'v2.eventApps.snoball.statusInactive') | translate"
      (change)="onStatusToggled(config, $event)"
    />
    <div class="tw-flex tw-h-5 tw-w-10 tw-items-center tw-rounded-full tw-bg-gray-200 tw-p-[2px] tw-transition-colors peer-checked:tw-justify-end peer-checked:tw-bg-blue-600 peer-disabled:tw-opacity-60">
      <div class="tw-h-4 tw-w-4 tw-shrink-0 tw-rounded-full tw-bg-white"></div>
    </div>
  </label>
</ng-template>

<ng-template #rowActions let-config>
  <button
    type="button"
    class="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-text-blue-600 hover:tw-bg-gray-100"
    [ngxTippy]="'v2.eventApps.snoball.edit' | translate"
    [tippyProps]="iconActionTippyProps"
    [attr.aria-label]="'v2.eventApps.snoball.edit' | translate"
    (click)="onEditRequested(config)"
  >
    <svg class="tw-pointer-events-none tw-text-blue-600" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g [attr.clip-path]="'url(#snoball-config-edit-' + config.id + ')'">
        <path
          class="tw-fill-blue-600"
          d="M15.5645 0.776507L13.9681 2.46272L17.6433 6.34452L19.2387 4.65831C19.4801 4.40345 19.6715 4.10087 19.8021 3.76785C19.9328 3.43482 20 3.07788 20 2.71741C20 2.35694 19.9328 2 19.8021 1.66697C19.6715 1.33395 19.4801 1.03137 19.2387 0.776507C18.7435 0.278052 18.0857 0 17.4016 0C16.7176 0 16.0597 0.278052 15.5645 0.776507Z"
        />
        <path
          class="tw-fill-blue-600"
          d="M16.1736 7.89681L12.4984 4.015L7.58739 9.19769C7.44209 9.35087 7.34299 9.54607 7.3026 9.75867L6.75589 12.67C6.72226 12.8473 6.7306 13.0306 6.78017 13.2037C6.82974 13.3767 6.91901 13.5341 7.04005 13.662C7.16109 13.7898 7.31016 13.8841 7.474 13.9365C7.63784 13.9888 7.81139 13.9976 7.97923 13.9621L10.7356 13.3803C10.9365 13.3374 11.121 13.2328 11.2657 13.0795L16.1736 7.89681Z"
        />
        <path
          class="tw-fill-blue-600"
          d="M7.58739 9.19769C7.44209 9.35087 7.34299 9.54607 7.3026 9.75867L6.75589 12.67C6.72226 12.8473 6.7306 13.0306 6.78017 13.2037C6.82974 13.3767 6.91901 13.5341 7.04005 13.662C7.16109 13.7898 7.31016 13.8841 7.474 13.9365C7.63784 13.9888 7.81139 13.9976 7.97923 13.9621L10.7356 13.3803C10.9365 13.3374 11.121 13.2328 11.2657 13.0795L16.1736 7.89681L12.4984 4.015L7.58739 9.19769Z"
        />
        <path
          class="tw-fill-blue-600"
          d="M12.2573 14.3617C11.9668 14.6679 11.5973 14.8768 11.195 14.9622L7.51982 15.7384C7.18432 15.8091 6.83747 15.7914 6.51003 15.6866C6.18259 15.5818 5.8847 15.3933 5.64278 15.1378C5.40085 14.8823 5.22238 14.5677 5.1232 14.2218C5.02401 13.876 5.00718 13.5096 5.07419 13.1552L5.80903 9.27345C5.88988 8.84852 6.08765 8.45824 6.37756 8.1515L11.4912 2.75035C11.4628 2.648 11.4481 2.54194 11.4476 2.43528H2.25231C1.65513 2.43586 1.08256 2.68668 0.660294 3.13269C0.238023 3.5787 0.000550397 4.18345 0 4.8142V17.6211C0.000550397 18.2518 0.238023 18.8566 0.660294 19.3026C1.08256 19.7486 1.65513 19.9994 2.25231 20H14.3776C14.9748 19.9994 15.5473 19.7486 15.9696 19.3026C16.3919 18.8566 16.6293 18.2518 16.6299 17.6211V9.7433L12.2573 14.3617Z"
        />
      </g>
      <defs>
        <clipPath [attr.id]="'snoball-config-edit-' + config.id">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </button>
  <button
    type="button"
    class="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-text-red-600 hover:tw-bg-gray-100"
    [ngxTippy]="'v2.eventApps.snoball.delete' | translate"
    [tippyProps]="iconActionTippyProps"
    [attr.aria-label]="'v2.eventApps.snoball.delete' | translate"
    (click)="onDisconnectRequested(config)"
  >
    <svg class="tw-pointer-events-none tw-text-red-600" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g [attr.clip-path]="'url(#snoball-config-trash-' + config.id + ')'">
        <path
          class="tw-fill-red-600"
          d="M18.1481 4.21053H14.074V2.10526C14.074 1.54691 13.8594 1.01143 13.4774 0.616617C13.0953 0.221804 12.5772 0 12.037 0H7.96288C7.42263 0 6.9045 0.221804 6.52248 0.616617C6.14046 1.01143 5.92584 1.54691 5.92584 2.10526V4.21053H1.85177C1.58164 4.21053 1.32258 4.32143 1.13157 4.51884C0.94056 4.71624 0.833252 4.98398 0.833252 5.26316C0.833252 5.54233 0.94056 5.81007 1.13157 6.00748C1.32258 6.20489 1.58164 6.31579 1.85177 6.31579H2.87029V17.8947C2.87029 18.4531 3.0849 18.9886 3.46692 19.3834C3.84894 19.7782 4.36707 20 4.90733 20H15.0925C15.6328 20 16.1509 19.7782 16.5329 19.3834C16.9149 18.9886 17.1295 18.4531 17.1295 17.8947V6.31579H18.1481C18.4182 6.31579 18.6773 6.20489 18.8683 6.00748C19.0593 5.81007 19.1666 5.54233 19.1666 5.26316C19.1666 4.98398 19.0593 4.71624 18.8683 4.51884C18.6773 4.32143 18.4182 4.21053 18.1481 4.21053ZM7.96288 2.10526H12.037V4.21053H7.96288V2.10526ZM8.9814 15.7895C8.9814 16.0686 8.87409 16.3364 8.68308 16.5338C8.49207 16.7312 8.23301 16.8421 7.96288 16.8421C7.69275 16.8421 7.43369 16.7312 7.24268 16.5338C7.05167 16.3364 6.94436 16.0686 6.94436 15.7895V8.42105C6.94436 8.14188 7.05167 7.87414 7.24268 7.67673C7.43369 7.47932 7.69275 7.36842 7.96288 7.36842C8.23301 7.36842 8.49207 7.47932 8.68308 7.67673C8.87409 7.87414 8.9814 8.14188 8.9814 8.42105V15.7895ZM13.0555 15.7895C13.0555 16.0686 12.9482 16.3364 12.7572 16.5338C12.5661 16.7312 12.3071 16.8421 12.037 16.8421C11.7668 16.8421 11.5078 16.7312 11.3168 16.5338C11.1257 16.3364 11.0184 16.0686 11.0184 15.7895V8.42105C11.0184 8.14188 11.1257 7.87414 11.3168 7.67673C11.5078 7.47932 11.7668 7.36842 12.037 7.36842C12.3071 7.36842 12.5661 7.47932 12.7572 7.67673C12.9482 7.87414 13.0555 8.14188 13.0555 8.42105V15.7895Z"
        />
      </g>
      <defs>
        <clipPath [attr.id]="'snoball-config-trash-' + config.id">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </button>
</ng-template>

@if (isConfigFormModalOpen()) {
  <app-snoball-config-form-modal
    [eventApp]="eventApp()"
    [eventId]="eventId()"
    [availablePersonas]="availablePersonas()"
    [configuration]="configToEdit()"
    (saved)="onConfigurationsSaved()"
    (onCloseModal)="onConfigFormClosed()"
  />
}

@if (isDisconnectModalOpen()) {
  <delete-modal
    [id]="disconnectModalId"
    [message]="disconnectConfirmMessage()"
    [confirmBtnLabel]="'v2.eventApps.snoball.disconnect' | translate"
    [cancelBtnLabel]="'v2.common.cancel' | translate"
    (onDelete)="onDisconnectConfirmed()"
    (onCancel)="closeDisconnectModal()"
  ></delete-modal>
}
